import "./Contact.css";
import { MdOutlineEmail } from "react-icons/md";
import { RiMessengerLine } from "react-icons/ri";
import { RiWhatsappLine } from "react-icons/ri";
import React from "react";
import { useRef } from 'react';
import emailjs from '@emailjs/browser';

const Contact = () => {
  const form = useRef();

  const sendEmail = (e) => {
    e.preventDefault();

    emailjs
      .sendForm(
        "service_zy9ztz7",
        "template_3xsio6y",
        form.current,
        "287xd_RCG97PBsDP_"
      )
    
      e.target.reset();
  };

  return (
    <section id="contact">
      <h5>Get In Touch</h5>
      <h2>Contact Me</h2>

      <div className="container contact-container">
        <div className="contact-options">
          <div className="contact-option">
            <MdOutlineEmail className="contact-option-icon" />
            <h4>E-mail</h4>
            <h5>shivatheviru@gmail.com</h5>
            <a href="mailto:shivatheviru@gmail.com" target="_blank">
              Send a Message
            </a>
          </div>
          <div className="contact-option">
            <RiMessengerLine className="contact-option-icon" />
            <h4>Messenger</h4>
            <h5>Shiva Raj</h5>
            <a href="https://m.me/s.raj.94043" target="_blank">
              Send a Message
            </a>
          </div>
          <div className="contact-option">
            <RiWhatsappLine className="contact-option-icon" />
            <h4>Whatsapp</h4>
            <h5>+123456789</h5>
            <a
              href="https://api.whatsapp.com/send?phone=+917795648903"
              target="_blank"
            >
              Send a Message
            </a>
          </div>
        </div>
        {/* END OF CONTACT OPTIONS */}

        <form ref={form} onSubmit={sendEmail}>
          <input
            type="text"
            name="name"
            placeholder="Your Full Name"
            required
          />
          <input type="email" name="email" placeholder="Your Email" required />
          <input
            type="text"
            name="subject"
            placeholder="Email Subject"
            required
          />
          <textarea
            name="message"
            rows="7"
            placeholder="Your Message"
            required
          ></textarea>
          <button type="submit" className="btn btn-primary">
            Send Message
          </button>
        </form>
      </div>
    </section>
  );
};

export default Contact;
